// portal.client_project_access.access_level
export const ACCESS_LEVELS = ['viewer', 'tester', 'approver'] as const
export type AccessLevel = (typeof ACCESS_LEVELS)[number]

export const ACCESS_LEVEL_LABELS: Record<AccessLevel, string> = {
  viewer: 'Visualizador',
  tester: 'Testador',
  approver: 'Aprovador',
}

export function canApprove(level: AccessLevel): boolean {
  return level === 'approver'
}

/** Todo nível abre chamado desde 21/09/2026 (D5 do ciclo de horas). */
export function canSendBugs(level: AccessLevel): boolean {
  return ACCESS_LEVELS.includes(level)
}

/**
 * O maior nível de uma lista.
 *
 * Uma pessoa pode ter várias linhas de acesso no mesmo projeto (uma por
 * iniciativa, cada uma com o seu nível). Onde a pergunta é "esta pessoa entra
 * neste projeto, e com que poder", a resposta é o maior deles.
 */
export function highestLevel(levels: readonly AccessLevel[]): AccessLevel | null {
  let melhor: AccessLevel | null = null
  for (const nivel of levels) {
    if (melhor === null || ACCESS_LEVELS.indexOf(nivel) > ACCESS_LEVELS.indexOf(melhor)) {
      melhor = nivel
    }
  }
  return melhor
}

/** O que cada nível libera no painel, em uma frase para o cliente ler. */
export const ACCESS_LEVEL_FAZ: Record<AccessLevel, string> = {
  viewer: 'acompanha e abre chamados',
  tester: 'abre chamados e envia arquivos',
  approver: 'aceita entregas',
}

/**
 * O nível mínimo de cada gesto do painel.
 *
 * A tela lê daqui para decidir o que mostrar, e o banco cobra o mesmo por RLS e
 * RPC. Os dois precisam concordar: se a tela oferecer o que o banco recusa, a
 * pessoa clica e leva erro; se esconder o que o banco aceita, ela liga achando
 * que quebrou.
 */
export const GESTOS = {
  // D5 e D6 do ciclo de horas (21/09/2026): todo cliente consegue pedir. O
  // Visualizador abre chamado, com print, e conversa nele; a policy
  // bugs_client_insert cobra o mesmo, e a conversa sempre pediu só acesso
  relatar: 'viewer',
  // ADR-096: mover exige o Testador nas duas iniciativas, e a RPC cobra as
  // duas. Continua assim: abrir chamado ficou de todos, mover não
  moverChamado: 'tester',
  responderNoChamado: 'viewer',
  cadastrarFornecedor: 'tester',
  subirArquivo: 'tester',
  darFeedback: 'tester',
  aceitarEntrega: 'approver',
  recusarEntrega: 'approver',
} as const

export type Gesto = keyof typeof GESTOS

/** Este nível dá conta deste gesto? Nível ausente nunca dá. */
export function podeFazer(level: AccessLevel | null | undefined, gesto: Gesto): boolean {
  if (!level) return false
  return ACCESS_LEVELS.indexOf(level) >= ACCESS_LEVELS.indexOf(GESTOS[gesto])
}
